const socialsShare = () => {

    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;


    function copyText() {
        var input = document.querySelector('#textToCopy');
      
        if ( isSafari || iOS ) {
          // handle iOS devices
          input.contenteditable = true;
          input.readonly = false;
      
          var range = document.createRange();
          range.selectNodeContents(input);
      
          var selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          input.setSelectionRange(0, 999999);
        } else {
          // other devices are easy
          input.select()
        }
        document.execCommand('copy');
      }



    Array.from( document.querySelectorAll("[data-copy]") ).map( element => {
        element.addEventListener('click',function(e){
            element.textContent = 'Copied';
            element.setAttribute('disabled','disabled')
            element.style.background = 'none';
            copyText( element )
        });
    });
}

export default socialsShare;

